import { curriculumStore } from './curriculumStore'
import { classroomStore } from 'pages/Classroom/model/classroomStore'

let inflight = null

export async function ensureCurriculumLoaded({ force = false } = {}) {
	if (!force && curriculumStore.hydratedOnce) {
		return curriculumStore
	}

	if (inflight) return inflight

	inflight = Promise.all([
		curriculumStore.loadProgress({ force }),
		classroomStore.tasksLoadStatus === 'ready' ||
		classroomStore.tasksFetchedOnce
			? Promise.resolve()
			: classroomStore.refreshTasks().catch(() => null),
	])
		.then(() => curriculumStore)
		.finally(() => {
			inflight = null
		})

	return inflight
}
